<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { v4 as uuidv4 } from "uuid";
import keyBy from "lodash.keyby";

export default {
  name: "home",
  data() {
    return {
      cameFromShopify: false,
      shopifyListId: "",
    };
  },
  computed: {
    ...mapGetters(["credentials", "token", "isIframe", "products"]),
    ...mapState(["iframeProducts", "iframeParentUrl"]),
    productsToSendToIframe() {
      if (this.token) {
        return this.products.filter(
          (product) => product.merchantUrl === this.iframeParentUrl
        );
      }
      return this.iframeProducts;
    },
  },

  methods: {
    ...mapActions([
      "getProducts",
      "getCategories",
      "setCredentials",
      "getSharedProducts",
      "getProductsAlarms",
      "addListIdToUser",
      "setIframeFlag",
      "setIframeProducts",
      "setIframeParentUrl",
    ]),

    onKeyUp(event) {
      if (event.key === "Escape") {
        // escape key maps to keycode `27`
        this.onCloseIframe();
      }
    },

    onCloseIframe() {
      parent.postMessage(
        {
          message: "closeIframe",
          items: keyBy(this.productsToSendToIframe, "shopifyVariantId"),
        },
        "*"
      );
    },

    async getrCredentialsFromLocalStorage() {
      let credentials = localStorage.getItem("credentials");
      credentials =
        credentials && credentials !== "undefined"
          ? JSON.parse(credentials)
          : "";
      if (!this.token && credentials) {
        await this.setCredentials(credentials);
        await this.getProducts();
        await this.getCategories();
        this.getProductsAlarms();
      }
    },

    async onIframeMessage(event) {
      console.log(JSON.stringify(event.data));
      const data = event.data;
      if (data.message === "iframeLoaded") {
        this.setIframeFlag(true);
        this.shopifyListId = data.value;
        this.cameFromShopify = true;
        let credentials = localStorage.getItem("credentials");
        credentials =
          credentials && credentials !== "undefined"
            ? JSON.parse(credentials)
            : "";
        if (credentials) {
          this.cameFromShopify = false;
          await this.addListIdToUser(data.value);
          console.log(data.value);
        }
        this.setIframeProducts(event.data.products);
        this.setIframeParentUrl(event.data.merchantUrl);
        //   this.$router.push({ path: "sharing" });
      } else if (data.message === "checkReadyState") {
        parent.postMessage({ message: "checkReadyState" }, "*");
      }
    },
  },

  mounted() {
    // wait for message from iframe
    window.addEventListener("message", this.onIframeMessage, false);
    this.getrCredentialsFromLocalStorage();

    setTimeout(() => this.getrCredentialsFromLocalStorage(), 2 * 1000);
  },

  beforeDestroy() {
    if (this.isIframe) {
      window.removeEventListener("keyup", this.onKeyUp);
      window.removeEventListener("message", this.onIframeMessage);
    }
  },
  watch: {
    isIframe(newVal) {
      if (newVal) {
        window.addEventListener("keyup", this.onKeyUp);
      }
    },
    async token(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.cameFromShopify) {
          await this.addListIdToUser(this.shopifyListId);
          this.cameFromShopify = false;
        }
        await this.getProducts();
      }
    },
  },
};
</script>

<style scoped></style>
